<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">办公系统</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/workflow/articlePaper' }">发文管理</el-breadcrumb-item>
                <el-breadcrumb-item>内部推文</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <!-- <div class="header-bar">
            <el-tag size="small" @click="$router.push({ path: '/workflow/articlePaper?type=月刊' })"
                style="font-weight: bold; cursor: pointer !important;">月刊</el-tag>
            <el-tag size="small" @click="$router.push({ path: '/workflow/articlePaper?type=推荐' })"
                style="margin-left: 10px; font-weight: bold; cursor: pointer !important;">推荐</el-tag>
        </div> -->

        <div class="article-container">
            <div class="article-content">
                <h2>{{ article.title }}</h2>
                <h4 v-if="article.subTitle">{{ article.subTitle }}</h4>
                <p class="article-date">
                    <span>发布时间：{{ article.publishDate }} </span>
                    <span v-if="article.publishDeptName">部门：{{ article.publishDeptName }} </span>
                    <span v-if="article.publishUserName">编辑：{{ article.publishUserName }} </span>
                </p>
                <div class="article-text" v-html="article.content"></div>

                <!-- 附件列表 -->
                <div v-if="fileList.length > 0" class="attachments-section">
                    <el-divider content-position="left">
                        <el-icon>
                            <Paperclip />
                        </el-icon>
                        附件列表
                    </el-divider>
                    <el-table :data="fileList" stripe style="width: 100%;">
                        <el-table-column type="index" label="序号" width="60" align="center" />
                        <el-table-column prop="name" label="文件名" show-overflow-tooltip>
                            <template #default="{ row }">
                                <el-link type="primary" @click="previewHandle(row)" :underline="false">
                                    <el-icon>
                                        <Document />
                                    </el-icon>
                                    {{ row.name }}
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="date" label="上传时间" width="180" />
                        <el-table-column label="操作" width="150" align="center">
                            <template #default="{ row }">
                                <el-button link size="small" type="primary" @click="previewHandle(row)">
                                    <el-icon>
                                        <ZoomIn />
                                    </el-icon>
                                    预览
                                </el-button>
                                <el-button link size="small" type="primary" @click="downloadHandle(row)">
                                    <el-icon>
                                        <Download />
                                    </el-icon>
                                    下载
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="article-actions">
                    <el-button class="btn-action" type="default" @click="actionOperation('1')" icon="CaretTop">{{
                        article.likeCount }} 赞同</el-button>
                    <el-button class="btn-comment" type="default" @click="showComment = !showComment"
                        icon="ChatSquare">评论</el-button>
                </div>
            </div>

            <form v-if="showComment" @submit.prevent>
                <el-image>
                    <template #error>
                        <div class="image-slot">{{ $store.getters.getUserInfo.userName.charAt(0).toUpperCase() }}
                        </div>
                    </template>
                </el-image>
                <el-input v-model="commentText" style="width:calc(100% - 120px); height: 35px;" placeholder="写评论..."
                    clearable @keydown.enter.prevent />
                <el-button type="primary" style="width: 80px;" @click="actionOperation('2');">提交</el-button>
            </form>
            <div v-if="showComment" class="comments-section">
                <div v-for="(comment, index) in comments" :key="comment.id" class="comment-item">
                    <div class="comment-main">
                        <el-image>
                            <template #error>
                                <div class="image-slot" :style="{ backgroundColor: colors[index % colors.length] }"
                                    :title="comment.userName || '无名'">
                                    {{ (comment.userName || '无名').charAt(0).toUpperCase() }}
                                </div>
                            </template>
                        </el-image>
                        <div class="comment-body">
                            <span class="comment-author">{{ comment.userName || '无名' }}</span>
                            <div class="comment-content">
                                {{ comment.commentText || '暂无评论' }}
                            </div>
                            <div class="comment-footer">
                                <span class="comment-time">{{ comment.actionDate }}</span>
                                <span class="comment-location" v-if="comment.location">· {{ comment.location }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!comments || comments.length === 0" class="no-comments">暂无评论</div>
            </div>
        </div>
    </el-card>
</template>


<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute();
import kaung from '@/utils/kaung.js'
import { fetchFileList } from '@/api/basic'
import { ZoomIn, Download } from '@element-plus/icons-vue'

const colors = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#E0E0E0'];
const showComment = ref(true);


const article = ref({})
const fileList = ref([])

const loadPaper = () => {
    let id = route.query.id;
    if (!id) return;

    console.log(id)

    kaung.fetch({
        url: '/FlowArticle/' + id,
        method: 'get'
    }).then((res) => {
        article.value = { ...res.data };
        // 加载附件列表
        loadFileList();
    }).catch((error) => {
        kaung.error(error.message)
    })
}

// 加载附件列表
const loadFileList = () => {
    const dataID = article.value.uniqueCode || article.value.id
    if (!dataID) return

    fetchFileList(dataID).then((res) => {
        if (res.code === 200) {
            fileList.value = res.data || []
        }
    })
}

// 预览文件
const previewHandle = (file) => {
    window.open('/preview?id=' + file.id)
}

// 下载文件
const downloadHandle = (file) => {
    window.open(file.url)
}



const comments = ref();

const loadComments = () => {
    let id = route.query.id;
    if (!id) return;

    kaung.fetch({ url: '/FlowArticle/GetComments?articleID=' + id, method: 'get' })
        .then((res) => {
            comments.value = res.data.data;
        }).catch((error) => {
            kaung.error(error.message)
        });
};


const loadPager = () => {
    loadPaper();
    loadComments();
};

// 初始加载
loadPager();

// 监听路由变化，当 query.id 变化时重新加载
watch(
    () => route.query.id,
    (newId, oldId) => {
        if (newId && newId !== oldId) {
            console.log('Route query.id changed:', oldId, '->', newId);
            // 重置数据
            article.value = {};
            fileList.value = [];
            comments.value = [];
            commentText.value = '';
            // 重新加载
            loadPager();
        }
    }
);


const commentText = ref('')

function addComment() {
    if (commentText.value.trim()) {
        comments.value.push({
            id: Date.now(),
            author: '当前用户',
            text: commentText.value
        })
        commentText.value = ''
    }
}

function actionOperation(type) {
    let id = route.query.id;
    if (!id) return;

    // 如果是提交评论，需要验证内容
    if (type === '2') {
        const content = commentText.value.trim();

        // 检查是否为空
        if (!content) {
            kaung.error('请输入评论内容');
            return;
        }

        // 检查字数（中文算1个字，英文数字算0.5个字）
        const chineseCount = (content.match(/[\u4e00-\u9fa5]/g) || []).length;
        const otherCount = content.replace(/[\u4e00-\u9fa5]/g, '').length;
        const totalLength = chineseCount + otherCount * 0.5;

        if (totalLength < 5) {
            kaung.error('评论内容过少，请至少输入5个字');
            return;
        }

        // 检查是否全是数字或字母
        if (/^[a-zA-Z0-9\s]+$/.test(content)) {
            kaung.error('评论内容过于简单，请输入有意义的内容');
            return;
        }
    }

    kaung.fetch({
        url: '/FlowArticle/SubmitAction?articleID=' + id, method: 'post',
        params: { actionType: type, commentText: commentText.value.trim() }
    })
        .then((res) => {
            loadPager();
            commentText.value = '';
        }).catch((error) => {
            kaung.error(error.message)
        });
}
</script>

<style scoped>
.article-container {
    width: 70%;
    max-width: 900px;
    margin: 0px auto;
    padding: 10px 15px;
    background: #fff;
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
}

.article-content {
    margin-bottom: 20px;
}

.article-content h2 {
    color: #000;
    text-align: center;
    font-size: 35px;
    letter-spacing: 5px;
    padding-bottom: 10px;
    border-bottom: #000 2px solid;
    /* font-weight: 500; */
    font-family: "微软雅黑";
}

.article-content h4 {
    text-align: center;
    font-size: 20px;
    margin: 10px 0 20px 0;
    font-family: "微软雅黑";
}

.article-date {
    color: #666;
    font-size: 13px;
    margin: 5px 0 12px 0;
    text-align: right;
}

.article-date span:not(:last-child)::after {
    content: " ";
    margin: 0 3px;
    color: #ccc;
}

.article-text {
    font-size: 15px;
    line-height: 1.5;
    color: #333;
    margin: 15px 0;
    word-wrap: break-word;
    word-break: break-word;
}

/* 段落 */
.article-text :deep(p) {
    margin: 5px 0;
    line-height: 1.5;
}

/* 标题 */
.article-text :deep(h1) {
    font-size: 28px;
    font-weight: 600;
    margin: 18px 0 12px 0;
    line-height: 1.3;
    color: #000;
}

.article-text :deep(h2) {
    font-size: 24px;
    font-weight: 600;
    margin: 16px 0 10px 0;
    line-height: 1.3;
    color: #000;
}

.article-text :deep(h3) {
    font-size: 20px;
    font-weight: 600;
    margin: 14px 0 8px 0;
    line-height: 1.3;
    color: #333;
}

.article-text :deep(h4) {
    font-size: 18px;
    font-weight: 600;
    margin: 12px 0 8px 0;
    line-height: 1.3;
    color: #333;
}

.article-text :deep(h5) {
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0 6px 0;
    line-height: 1.3;
    color: #333;
}

/* 列表 */
.article-text :deep(ul),
.article-text :deep(ol) {
    margin: 8px 0;
    padding-left: 28px;
    line-height: 1.6;
}

.article-text :deep(li) {
    margin: 4px 0;
}

.article-text :deep(ul ul),
.article-text :deep(ol ul),
.article-text :deep(ul ol),
.article-text :deep(ol ol) {
    margin: 4px 0;
}

/* 引用块 */
.article-text :deep(blockquote) {
    border-left: 4px solid #409eff;
    background-color: #f9f9f9;
    padding: 10px 14px;
    margin: 12px 0;
    color: #666;
    font-style: italic;
}

/* 行内代码 */
.article-text :deep(code) {
    background-color: #f5f7fa;
    padding: 3px 8px;
    border-radius: 3px;
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
    font-size: 14px;
    color: #e03997;
    border: 1px solid #ebeef5;
}

/* 代码块 */
.article-text :deep(pre) {
    background-color: #f5f7fa;
    padding: 12px;
    border-radius: 4px;
    overflow-x: auto;
    margin: 12px 0;
    border: 1px solid #ebeef5;
}

.article-text :deep(pre code) {
    background-color: transparent;
    padding: 0;
    border: none;
    color: #333;
    font-size: 13px;
    line-height: 1.5;
}

/* 表格 */
.article-text :deep(table) {
    width: 100%;
    border-collapse: collapse;
    margin: 12px 0;
    border: 1px solid #dcdfe6;
}

.article-text :deep(table th),
.article-text :deep(table td) {
    border: 1px solid #dcdfe6;
    padding: 8px 10px;
    text-align: left;
    line-height: 1.5;
}

.article-text :deep(table th) {
    background-color: #f5f7fa;
    font-weight: 600;
    color: #333;
}

.article-text :deep(table tr:nth-child(even)) {
    background-color: #fafafa;
}

.article-text :deep(table tr:hover) {
    background-color: #f5f7fa;
}

/* 链接 */
.article-text :deep(a) {
    color: #409eff;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    transition: all 0.3s;
}

.article-text :deep(a:hover) {
    color: #66b1ff;
    border-bottom-color: #66b1ff;
}

/* 图片 */
.article-text :deep(img) {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
    margin: 10px 0;
    display: block;
}

/* 分割线 */
.article-text :deep(hr) {
    border: none;
    border-top: 2px solid #ebeef5;
    margin: 16px 0;
}

/* 文本样式 */
.article-text :deep(strong),
.article-text :deep(b) {
    font-weight: 600;
    color: #000;
}

.article-text :deep(em),
.article-text :deep(i) {
    font-style: italic;
}

.article-text :deep(u) {
    text-decoration: underline;
}

.article-text :deep(s),
.article-text :deep(del) {
    text-decoration: line-through;
    color: #999;
}

/* 对齐方式 */
.article-text :deep([style*="text-align: center"]),
.article-text :deep(.center) {
    text-align: center;
}

.article-text :deep([style*="text-align: right"]),
.article-text :deep(.right) {
    text-align: right;
}

/* 嵌套缩进 */
.article-text :deep(p[style*="text-indent"]) {
    text-indent: 2em;
}

.attachments-section {
    margin: 24px 0;
    padding: 16px 0;
    /* border-top: 1px solid #f0f0f0; */
}

.attachments-section .el-divider {
    margin: 0 0 16px 0;
}

.attachments-section :deep(.el-table) {
    font-size: 14px;
}

.attachments-section :deep(.el-link) {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.article-actions {
    margin-top: 16px;
}

.comments-section {
    border-top: 1px solid #eee;
    padding: 15px 0;
    max-width: 98%;
    margin: 0px auto;
}

.comment-item {
    padding: 12px 0;
    margin-bottom: 12px;
    border-bottom: 1px solid #f3f3f3;
}

.comment-item:last-child {
    border-bottom: none;
}

.comment-main {
    display: flex;
    align-items: flex-start;
}

.comment-main .el-image {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-right: 12px;
}

.comment-body {
    flex: 1;
    min-width: 0;
}

.comment-author {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    display: block;
    margin-bottom: 4px;
}

.comment-content {
    font-size: 14px;
    line-height: 1.6;
    color: #333;
    margin: 4px 0;
    word-wrap: break-word;
}

.comment-footer {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #999;
}

.comment-time {
    color: #999;
}

.comment-location {
    margin-left: 4px;
    color: #999;
}

.no-comments {
    text-align: center;
    color: #999;
    padding: 20px;
    font-size: 14px;
}

form {
    display: flex;
    gap: 8px;
    margin: 10px auto;
}

form .el-image {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    text-align: center;
    overflow: hidden;
    margin-top: 0px;
}

form .el-image:hover .image-slot {
    cursor: pointer;
    background: #000000;
}

.btn-action {
    padding: 8px 16px;
    border: none;
    background: #daecff;
    color: #1772f6;
    border-radius: 4px;
    cursor: pointer;
}

.btn-vote,
button:hover {
    background: #1772f6;
    color: #fff;
}

.image-slot {
    line-height: 30px;
    color: white;
    background-color: #a0a0a0;
    text-align: center;
    font-size: 12px;
}
</style>